import {WithSummaryModel} from "../../../../../../../common/entity/dto/plain/withSummary.model";

import {TreatmentJourneyStepSummaryModel} from "../../../step/api/entity/treatmentJourneyStepSummary.model";
import {
    TreatmentDefinitionSummaryModel
} from "../../../../../treatment-definition/api/entity/treatmentDefinitionSummaryModel";
import {
    ConsultationCategorySummaryModel
} from "../../../../../../consultation/category/api/model/consultationCategorySummary.model";
import {TreatmentJourneyStepReminderModel} from "./treatmentJourneyStepReminder.model";
import {TreatmentJourneyStepFeedbackModel} from "./treatmentJourneyStepFeedback.model";

export class TreatmentJourneyStepModel extends WithSummaryModel<TreatmentJourneyStepSummaryModel> {

    treatmentFormDefinition: TreatmentDefinitionSummaryModel;
    consultationCategory: ConsultationCategorySummaryModel;
    emailSubject: string;
    emailContent: string;
    reminders: TreatmentJourneyStepReminderModel[] = [];
    feedbacks: TreatmentJourneyStepFeedbackModel[] = [];
}